/**
 * Formatage de dates en français, partagé.
 *
 * POURQUOI CE FICHIER
 * `toLocaleDateString('fr-FR', …)` était réimplémenté à l'identique dans chaque écran —
 * quatre fois dans le seul `CalendarScreen.tsx`. Chaque copie porte ses propres options,
 * donc un même type de date pouvait s'afficher différemment d'un écran à l'autre, et
 * corriger un format obligeait à les retrouver toutes.
 *
 * `ui/src/utils/` ne contenait jusqu'ici que `indicators.ts`.
 */

const LOCALE = 'fr-FR';

/** Clé locale `YYYY-MM-DD`, sans passage par UTC.
 *
 * ⚠️ Ne PAS utiliser `toISOString().slice(0, 10)` : il convertit en UTC et décale la
 * date d'un jour pour tout fuseau à l'est de Greenwich, en début ou fin de journée.
 */
export const toDateKey = (d: Date): string =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** « septembre 2026 » — en-tête de mois. */
export const formatMois = (d: Date): string =>
    d.toLocaleDateString(LOCALE, { month: 'long', year: 'numeric' });

/** « septembre 2026 » à partir d'une date ISO, pour regrouper une liste par mois. */
export const formatMoisAnnee = (iso: string): string =>
    new Date(iso).toLocaleDateString(LOCALE, { year: 'numeric', month: 'long' });

/** « lun. » — libellé court de jour. */
export const formatJourCourt = (d: Date): string =>
    d.toLocaleDateString(LOCALE, { weekday: 'short' });

/** « lundi 21 septembre 2026 » — date complète, pour un panneau de détail. */
export const formatDateComplete = (d: Date | string): string =>
    (typeof d === 'string' ? new Date(d) : d).toLocaleDateString(LOCALE, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

/** « 21 sept. 2026 » — format compact. */
export const formatDateCourte = (d: Date | string): string =>
    (typeof d === 'string' ? new Date(d) : d).toLocaleDateString(LOCALE, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
